import React from "react"
import { FaMinus } from "react-icons/fa"
import { type Props } from "./_types"
const IconMinus: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <FaMinus size={size} color={color} />
}

export default IconMinus
